import { createSlice } from "@reduxjs/toolkit";
import { CollectionState } from "types/collection";
import { fetchCollectionsThunk, fetchCreatorsCollectionItemsThunk, fetchPostCollectionItemsThunk } from "./thunk";

const initialState: CollectionState = {
    list_loading: true,
    list_error: null,
    list: null,
    last_fetched_at: 0,
    collections: {}
}

const state = createSlice({
    name: 'collections',
    initialState,
    reducers: {
        
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCollectionsThunk.pending, (state) => {
            state.list_loading = true;
            state.list_error = null;
        })
        builder.addCase(fetchCollectionsThunk.fulfilled, (state, action) => {
            state.list_loading = false;
            state.list = action.payload.response;
            state.last_fetched_at = action.payload.cached ? state.last_fetched_at : Date.now();
        })
        builder.addCase(fetchCollectionsThunk.rejected, (state, action) => {
            state.list_loading = false;
            state.list_error = action.payload ?? 'Failed to fetch collections!';
        })
        builder.addCase(fetchPostCollectionItemsThunk.fulfilled, (state, {payload}) => {
            const {items, count, filters, filterId, collectionId} = payload;
            const collection = state.collections[collectionId];
            const existingData = collection?.data?.items?.filtered_lists?.[filterId]?.items ?? [];
            const finalList = filters.page === 1 ? items : [...existingData, ...items];
            state.collections[collectionId] = {
                ...(collection ?? {}),
                data: {
                    ...(collection?.data ?? {}),
                    items: {
                        total: finalList.length,
                        filtered_lists: {
                            ...(collection?.data?.items?.filtered_lists ?? {}),
                            [filterId]: {
                                items: finalList,
                                count: finalList.length,
                                filters: filters,
                                last_fetched_at: Date.now(),
                                has_more: items.length > 0,
                                page: filters.page,
                                expired: false
                            }
                        }
                    }
                }
            }
            
        }) 
        builder.addCase(fetchCreatorsCollectionItemsThunk.fulfilled, (state, {payload}) => {
            const {items, count, filters, filterId, collectionId} = payload;
            const collection = state.collections[collectionId];
            const existingData = collection?.data?.items?.filtered_lists?.[filterId]?.items ?? [];
            const finalList = filters.page === 1 ? items : [...existingData, ...items];
            state.collections[collectionId] = {
                ...(collection ?? {}),
                data: {
                    ...(collection?.data ?? {}),
                    items: {
                        total: finalList.length,
                        filtered_lists: {
                            ...(collection?.data?.items?.filtered_lists ?? {}),
                            [filterId]: {
                                items: finalList,
                                count: finalList.length,
                                filters: filters,
                                last_fetched_at: Date.now(),
                                has_more: items.length > 0,
                                page: filters.page,
                                expired: false
                            }
                        }
                    }
                }
            }
            
        }) 
    }
})

export default state.reducer
